module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/user-profile/user-profile.component.scss
// module id = ./src/app/ui/user-profile/user-profile.component.scss
// module chunks = main